angular.module("ainapp")
    .controller("lessSellingItemsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Less Selling Items";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    Keyword: "",
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                }
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.SortValue = "Less";

                        o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                        o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                        MainService.MostSellingItemsReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            TotalSales: {
                                type: "number",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "ProductCode",
                        title: "Product Code",
                    },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                    },
                    {
                        field: "ParentGroupName",
                        title: "Category",
                    },
                    {
                        field: "GroupName",
                        title: "Sub Category",
                    },
                    {
                        field: "Unit.Name",
                        title: "Unit",
                    },
                    {
                        field: "TotalSales",
                        title: "Total Sales",
                    }
                ],
            };


            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Recalculate = function (id) {
                MainService.RecalculateProductStockBalance(id).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    } else {
                        toastr.error("Network Error");
                    }
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
